"use client";
import * as React from "react";
const SvgSavingsOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.4 6.82c0-.44.36-.8.8-.8s.8.36.8.8-.36.79-.8.79-.8-.36-.8-.8m-5.6-.78h4V4.45h-4zM16 4.84v5.5l-2.26.75-1.34 4.41H8v-1.58H6.4v1.58H2S0 8.82 0 6.42s1.97-4.34 4.4-4.34h4A4 4 0 0 1 11.6.5c.66 0 1.2.53 1.2 1.18q0 .25-.1.46a4 4 0 0 0-.25.91l1.81 1.8zm-1.6 1.58h-.8l-2.8-2.76q0-.78.2-1.51a2.4 2.4 0 0 0-1.66 1.5H4.4a2.8 2.8 0 0 0-2.8 2.77c0 1.48.98 5.25 1.6 7.5h1.6v-1.58h4.8v1.58h1.6l1.25-4.07 1.95-.64z" }));
export {
  SvgSavingsOutlined as default
};
